import { TRDocumentView } from './TRDocumentView'
export default TRDocumentView
